import React from 'react';
import churroImg from '../assets/churroschocalate.jpeg';
import empImg from '../assets/churro2.jpeg';
import './Testimonials.css';

const Testimonials = () => {
  return (
    <section id="favorites" className="testimonials">
      <div className="testimonials__container">
        <div className="testimonials__header">
          <span className="testimonials__label">The Local Favorites</span>
          <h2 className="testimonials__heading">
            The Heart of <span>Churros ATX</span>
          </h2>
          <p className="testimonials__subheading">
            If it's your first time at the trailer, start here.
          </p>
        </div>
        <div className="testimonials__favorites-grid">
          <div className="testimonials__favorite-card">
            <div className="testimonials__favorite-image">
              <img src={churroImg} alt="Signature 2-Pack Churros" />
              <div className="testimonials__favorite-badge">Fan Favorite</div>
            </div>
            <div className="testimonials__favorite-content">
              <h3 className="testimonials__favorite-title">The Signature 2-Pack Churros</h3>
              <p className="testimonials__favorite-text">
                Our most loved tradition. Two large, hand-pressed churros made from our 
                proprietary vegan dough, fried to a golden crunch and dusted with our 
                signature cinnamon-sugar blend. Add a side of our warm Dulce de Leche 
                for the ultimate "life-changing" treat.
              </p>
            </div>
          </div>
          <div className="testimonials__favorite-card">
            <div className="testimonials__favorite-image">
              <img src={empImg} alt="Heritage Beef Empanada" />
              <div className="testimonials__favorite-badge">Must Try</div>
            </div>
            <div className="testimonials__favorite-content">
              <h3 className="testimonials__favorite-title">The Heritage Beef Empanada</h3>
              <p className="testimonials__favorite-text">
                A savory masterpiece wrapped in a golden, flaky crust. We slow-cook our 
                beef with a traditional garden blend of carrots, celery, onions, and garlic 
                to create a filling that tastes like home. Every empanada is served with a 
                side of our famous Homemade Tomatillo Salsa for that perfect kick.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
